import React from "react";
import "./style.css";
import axios from "axios";
import { FactCheckOutlined } from "@mui/icons-material";
import AddSessionModal from "./modal-addsession";

const faNumbers = require("../../../../../utils/numbersFa.js");

class Offline extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogin: false,
      clinicUsers: null,
      listedUsers: null,
      sendMessage: "Hello,I'mInEvaluationsPage",
      evaluation: null,
      currentDateTime: null,
      openModal: false,
      errorModal: false,
      modalClinicUser: "",
      modalUserId: "",
      videocallSession: false,
      sessName: 0,
      currentUser: 0,
      openAddModal: false,
      products: null,
      userSearch: "",
    };
  }

  getCurrentDateAndTime = () => {
    var today = new Date();
    var randDate = new Date("2022-5-3 7:0:0");

    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " " + time;

    console.log("Current Date is:", dateTime);
    console.log("Current Date is:", today.getTime());
    console.log("Current Date is:", randDate < today);
  };

  componentDidMount = async () => {
    const userResult = await axios.get("https://request.kidiar.com/user/request", {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    localStorage.setItem("currentUser", userResult.data.access);
    if (userResult.data.message == "Yo, You are authenticated!") {
      // this.setState({isLogin: true});
      this.setState({ currentUser: userResult.data.user });
      this.setState({ products: userResult.data.user.products });
      console.log(userResult.data);
    } else {
      // this.setState({isLogin: false});
      window.location.href = "https://www.mehrobo.com/fa/login";
    }
    this.handleRedirect();

    const result = await axios.post(
      "https://request.kidiar.com/user/list",
      { some: "some" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    console.log("Received Data:", result.data);
    if (result.data.message == "Yo, You are authenticated!") {
      this.setState({ isLogin: true });
      this.setState({ clinicUsers: result.data.users });
      this.setState({ listedUsers: result.data.users });
      this.setState({ isLogin: true });
      this.getCurrentDateAndTime();
    } else {
      this.setState({ isLogin: false });
      window.location.href = "https://www.mehrobo.com/fa/login";
    }
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  modalHandler(modal) {
    this.setState({ openAddModal: false });
  }

  addSessionModal() {
    this.setState({ openAddModal: true });
  }

  filterUsersBySearch(filter) {
    let arr = [];
    let len = filter.length;

    if (filter === "") {
      this.setState({ listedUsers: this.state.clinicUsers });
      return;
    }

    for (let i = 0; i < this.state.clinicUsers.length; i++) {
      if (
        this.state.clinicUsers[i].firstname.substr(0, len) === filter ||
        this.state.clinicUsers[i].lastname.substr(0, len) === filter
      ) {
        arr.push(this.state.clinicUsers[i]);
      }
    }
    console.log(filter, arr);
    this.setState({ listedUsers: arr });
  }

  render() {
    if (this.state.isLogin == false) {
      return <div className="container-fluid"></div>;
    }

    return (
      <div className="container-fluid">
        <div className="row no-gutters">
          <div className="col-12">
            <div className="d-flex mb-3 align-items-center">
              <div className="d-flex flex-column ml-2">
                <p className="d-flex mb-2 align-items-center">
                  <span className="font-medium font-18 mode-text-2">
                    مدیریت جلسات
                  </span>
                </p>
              </div>
            </div>
            <div className="test-list mt-1 d-flex flex-column">
              {this.state.openAddModal && (
                <AddSessionModal
                  closeModal={(modalBool) => this.modalHandler(modalBool)}
                  clinicUsers={this.state.clinicUsers}
                  selectedUser={this.state.userId}
                  currentUser={this.state.currentUser}
                />
              )}
              <div className="boxes my-4 mb-4" style={{ gridGap: "0" }}>
                <a
                  className="box d-flex flex-column align-items-center justify-content-center"
                  onClick={() => this.addSessionModal()}
                >
                  <div className="evaluations-add-btn d-flex align-items-center justify-content-center">
                    <span style={{ color: "#3ecc97" }}> + </span>
                  </div>
                  <span className="font-14 mt-4 mode-text-7">افزودن جلسه</span>
                </a>
              </div>
              <div className="panel mode-bg-8 mb-4">
                <div className="d-flex flex-column w-100">
                  <div
                    className="test-title-wrapper d-flex justify-content-between align-items-center pr-4 pl-4"
                    style={{ paddingTop: "0.5rem" }}
                  >
                    <div className="test-table">
                      <div className="table-row">
                        <input
                          placeholder="کاربر را جستجو کنید ..."
                          className="test-table-row w-100 d-flex align-items-center mode-bg-9 font-16 pr-4 pl-4"
                          onChange={(e) =>
                            this.filterUsersBySearch(e.target.value)
                          }
                        ></input>
                      </div>
                    </div>
                  </div>
                  <div
                    className="test-table-wrapper"
                    style={{ paddingTop: "0.5rem" }}
                  >
                    <div className="test-table">
                      <div className="table-head">
                        <div className="test-table-header d-flex align-items-center mode-bg-5 pr-4 pl-4">
                          <p className="mode-text-9 w-15">ردیف</p>
                          <p className="mode-text-9 w-35">نام کاربر</p>
                          <p className="mode-text-9 w-35">نوع کاربر</p>
                          <p className="mode-text-9 w-35 d-flex justify-content-end pr-4">
                            عملیات‌ها
                          </p>
                        </div>
                      </div>
                      {this.state.listedUsers.map((clinicUser, i) => (
                        <div className="table-row" key={i}>
                          <a className="test-table-row w-100 d-flex align-items-center mode-bg-9 pr-4 pl-4">
                            <p className="mode-text-9 w-15">
                              {faNumbers[i + 1]}
                            </p>
                            <p className="mode-text-9 w-35">
                              {clinicUser.firstname} {clinicUser.lastname}
                            </p>
                            <p className="mode-text-9 w-35">
                              {clinicUser.access == "Therapist"
                                ? "درمانگر"
                                : "مراجع"}
                            </p>
                            <div className="w-50 d-flex justify-content-end">
                              <a
                                href={`/fa/panel/sessions/offline/list?id=${clinicUser.id}`}
                                className="users-control mode-text-0"
                                style={{ backgroundColor: "#3B38C1" }}
                              >
                                <FactCheckOutlined />
                              </a>
                            </div>
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Offline;
